import { useState } from "react";
import CheckBox from "../../../../components/CheckBox/Checkbox.component";
import {
  CalenderIcon,
  ThreeDots,
  UserProfileImg,
} from "../../../../../public/assets";
import {
  CheckboxCon,
  ProfileEmail,
  ProfileImgCon,
  ProfileName,
  ProfileNameEmailCon,
} from "./UserProfile.styles";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import ReassignRoleOtpModal from "./ReassignRoleOtpModal";
import ActionDropdown from "./ActionDropdown";
import DropDownSelect from "./DropDownSelect";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";
import { setCurrentRole } from "../../../../store/userManagement";
export interface userContent {
  id: string;
  role: string;
  status: string;
  fullName: string;
  firstName: string;
  lastName: string;
  email: string;
  index: number;
  isChecked: boolean;
  date: string;
  organization_role_id: string;
}

interface userContentProps {
  data: userContent;
  handleCheckboxChange: (index: number, e?: any) => void;
  index: number;
  showDropDown: boolean;
  handleShowDropDown: (index: number) => void;
  roles: { type: string; name: string }[];
  onRoleChange: (role: string, index: number) => void;
  handleCloseOtpModal: () => void;
  [key: string]: any;
}

const getStatusColor = (status: any) => {
  switch (status) {
    case "inactive":
      return "orange";
    case "active":
      return "green";
    case "Default":
      return "CFCFCF80";
    default:
      return "black";
  }
};
const getBackgroundColor = (status: string) => {
  switch (status) {
    case "inactive":
      return "#E89D2B1A";
    case "active":
      return "#4BB5431A";
    case "Default":
      return "#CFCFCF80";
    default:
      return "#CFCFCF80";
  }
};
const getBorderColor = (status: string) => {
  switch (status) {
    case "inactive":
      return "1px solid #E89D2B1A";
    case "active":
      return " 1px solid#4BB5431A";
    case "Default":
      return "1px solid #CFCFCF80";
    default:
      return "1px solid #CFCFCF80";
  }
};

const UserProfileContent: React.FC<userContentProps> = ({
  data,
  index,
  handleCheckboxChange,
  roles,
  handleCloseOtpModal,
  onRoleChange,
}) => {
  const dispatch = useDispatch();
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [showActionDropdown, setShowActionDropDown] = useState(false);
  const selectedRole = useSelector(
    (state: RootState) => state.userManagement.selectedRole
  );
  const handleRoleChange = (role: { type: string; name: string }) => {
    onRoleChange(role.name, index);
    setShowOtpModal(true);
  };

  const toggleActionDropDown = () => {
    setShowActionDropDown(!showActionDropdown);
  };

  const onCloseOtpModal = () => {
    setShowOtpModal(false);
    if (handleCloseOtpModal) {
      handleCloseOtpModal();
    }
  };
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {},
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
      backgroundColor: theme.palette.action.hover,
    },

    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  return (
    <>
      <StyledTableRow sx={{ width: "100%", display: "flex" }}>
        <StyledTableCell sx={{ width: "5%", padding: "16px 0px 16px 5px" }}>
          <CheckboxCon>
            <CheckBox
              checked={data.isChecked}
              onChange={(e: any) => handleCheckboxChange(index, e)}
              width="20px"
              height="20px"
            />
          </CheckboxCon>
        </StyledTableCell>
        <StyledTableCell sx={{ width: "30%" }}>
          <ProfileImgCon>
            <img
              src="/assets/svg/UserProfileImg.svg"
              alt="default profile img"
              style={{ marginLeft: "15px", marginRight: "5px" }}
            />

            <ProfileNameEmailCon>
              <ProfileName>
                {data.fullName || `${data.firstName} ${data.lastName}`}
              </ProfileName>
              <ProfileEmail>{data.email}</ProfileEmail>
            </ProfileNameEmailCon>
          </ProfileImgCon>
        </StyledTableCell>
        <StyledTableCell sx={{ width: "20%" }}>
          <DropDownSelect
            roleTitle={data.role}
            roles={roles}
            onRoleChange={handleRoleChange}
          />
        </StyledTableCell>
        <StyledTableCell sx={{ width: "15%" }}>
          <button
            style={{
              border: getBorderColor(data.status),
              padding: "5px 3px",
              width: "100%",
              borderRadius: "15px",
              color: getStatusColor(data.status),
              backgroundColor: getBackgroundColor(data.status),
            }}
          >
            {data.status}
          </button>
        </StyledTableCell>
        <StyledTableCell sx={{ width: "25%" }}>
          <div style={{ display: "flex", gap: "1rem" }}>
            <img
              src="/assets/svg/calendar.svg"
              alt="calender icon"
              style={{ width: "1.2rem", height: "1.2rem" }}
            />
            <span>
              <strong>Feb 04, 2023</strong> 02:30PM
            </span>
          </div>
        </StyledTableCell>
        <StyledTableCell sx={{ width: "5%" }}>
          <div style={{ position: "relative" }}>
            {showActionDropdown && (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  right: "90%",
                  width: "200px",
                }}
              >
                <ActionDropdown
                // setShowAction={setShowAction}
                // showAction={showAction}
                />
              </div>
            )}
            <img
              src="/assets/svg/icon.svg"
              alt="three vertical dots"
              onClick={toggleActionDropDown}
            />
          </div>
        </StyledTableCell>
      </StyledTableRow>
    </>
  );
};

export default UserProfileContent;
